import React from "react";
import { Dialog } from "primereact/dialog";

interface Props {
  visible: boolean;
  onHide: () => void;
}

export default function AjudaUpload({ visible, onHide }: Props) {
  return (
    <Dialog
      header="Documentação — Orientações"
      draggable={false}
      style={{ width: "420px" }}
      visible={visible}
      onHide={onHide}
    >
      <div className="ecf-ajuda-upload">
        <div className="ecf-ajuda-upload__item">
          <span className="ecf-ajuda-upload__badge">1</span>
          <span>
            No máximo <strong>3 arquivos</strong> por contribuição.
          </span>
        </div>
        <div className="ecf-ajuda-upload__item">
          <span className="ecf-ajuda-upload__badge">2</span>
          <div>
            <span>Formatos aceitos:</span>
            <div className="ecf-ajuda-upload__formats">
              <span>jpg</span>
              <span>jpeg</span>
              <span>png</span>
              <span>bmp</span>
              <span>doc</span>
              <span>docx</span>
              <span>odt</span>
              <span>rtf</span>
              <span>xls</span>
              <span>xlsx</span>
              <span>ods</span>
              <span>ppt</span>
              <span>pptx</span>
              <span>odp</span>
              <span>pdf</span>
              <span>txt</span>
              <span>dwg</span>
              <span>rar</span>
              <span>zip</span>
              <span>7z</span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
